// extracted by mini-css-extract-plugin
export default {"content":"content--juNmr","box":"box--JKnA4","title":"title--TsT9t","divider":"divider--OciMw","range":"range--jB6ij"};